<template>
  <v-app class="side-nav">
    <v-navigation-drawer
      v-model="controls.drawer"
      width="322px"
      class="main-layout-drawer"
      floating
      app
    >
      <v-layout
        align-center
        justify-center
        column
        class="app-logo-container "
        style="height: 250px"
      >
        <div>
          <v-img
            :src="require('@/assets/images/dimers-bright-yellow.png')"
            width="auto"
            height="74px"
            class="ma-6"
          ></v-img>
        </div>
        <!-- <div class="app-company--name mt-8">Dimers</div>
        <div class="app-project--name mt-2">Admin CMS</div> -->
      </v-layout>

      <!-- <v-list
        class="app-nav"
        flat
      > -->
      <!-- <v-subheader class="mb-5">
          <div class="app-nav--title mx-auto">NAVIGATION</div>
        </v-subheader> -->
      <!-- <v-list-item
          link
          active-class="white black--text"
          v-for="item in navItems[user.role]"
          :key="item.label"
          :to="item.to"
        >
          <v-list-item-content>
            <v-list-item-title class="pa-2 app-nav--item">{{
              item.label
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list> -->
      <v-list v-if="user.role === 'ADMIN'">
        <v-list-item
          :to="{name: 'adhesive-banners'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-billboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Adhesive Banners</v-list-item-title>
        </v-list-item>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-newspaper-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Articles</v-list-item-title>
              <v-list-item-action>

              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in articles"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>
        <v-list-item
          :to="{name: 'authors'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-library</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Authors</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item
          :to="{name: 'app-settings'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-cellphone-settings</v-icon>
          </v-list-item-icon>
          <v-list-item-title>App Settings</v-list-item-title>
        </v-list-item> -->
        <!-- <v-list-item
          :to="{name: 'bethub-pages'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-title>BetHub Pages Meta</v-list-item-title>
        </v-list-item> -->
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-bookshelf</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Bookmaker</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in bookmakers"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item
          :to="{name: 'editors'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-typewriter</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Editors</v-list-item-title>
        </v-list-item>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-television-guide</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Free to Play</v-list-item-title>
              <v-list-item-action>
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in freeToPlay"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>
        <v-list-item
          :to="{name: 'in-content-banners'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-file-table-box</v-icon>
          </v-list-item-icon>
          <v-list-item-title>In-content Conversion Banners</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{name: 'landing-page-builder'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-hammer</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Landing Page Builder</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{name: 'newsletter'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-email-newsletter</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Newsletter</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{name: 'onboarding'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-form-select</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Onboarding</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item
          :to="{name: 'page-settings'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-checkbook</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Page Settings</v-list-item-title>
        </v-list-item> -->
        <!-- <v-list-item
          :to="{name: 'teams-and-players'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-basketball-hoop</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Teams/Players</v-list-item-title>
        </v-list-item> -->

        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-microphone</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Podcast</v-list-item-title>
              <v-list-item-action>
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in podCast"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>
        <v-list-item
          :to="{name: 'publishers'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-child-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Publishers</v-list-item-title>
        </v-list-item>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-poker-chip</v-icon>
              </v-list-item-icon>
              <v-list-item-title>SB101</v-list-item-title>
              <v-list-item-action>
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in sportsbetting"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-keyboard-settings-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Settings</v-list-item-title>
              <v-list-item-action>

              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in settings"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-newspaper-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Sports</v-list-item-title>
              <v-list-item-action>

              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in sports"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>

        <!-- <v-list-item
          :to="{name: 'tags'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-tag-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Leagues</v-list-item-title>
        </v-list-item> -->
        <v-list-item
          :to="{name: 'users'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Users</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item
          to="user-guides"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-details</v-icon>
          </v-list-item-icon>
          <v-list-item-title>User Guides</v-list-item-title>
        </v-list-item> -->
      </v-list>
      <v-list v-else-if="user.role === 'EDITOR'">
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-newspaper-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Articles</v-list-item-title>
              <v-list-item-action>

              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in articles"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-bookshelf</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Bookmaker</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in bookmakers"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item
          :to="{name: 'landing-page-builder'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-hammer</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Landing Page Builder</v-list-item-title>
        </v-list-item>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-poker-chip</v-icon>
              </v-list-item-icon>
              <v-list-item-title>SB101</v-list-item-title>
              <v-list-item-action>
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in sportsbetting"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-keyboard-settings-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Settings</v-list-item-title>
              <v-list-item-action>

              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in settings"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-newspaper-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Sports</v-list-item-title>
              <v-list-item-action>

              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in sports"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>
      </v-list>
      <v-list v-else>
        <v-list-group
          no-action
          value="true"
        >
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-newspaper-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Articles</v-list-item-title>
              <v-list-item-action>

              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(menu, i) in articles"
            :key="i"
            :to="menu.to"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>

          </v-list-item>
        </v-list-group>
        <v-list-item
          :to="{name: 'authors'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-library</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Authors</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{name: 'in-content-banners'}"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>mdi-file-table-box</v-icon>
          </v-list-item-icon>
          <v-list-item-title>In-content Conversion Banners</v-list-item-title>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list>
          <v-menu
            top
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-list-item
                two-line
                v-on="on"
              >
                <v-list-item-avatar>
                  <user-avatar
                    size="40"
                    :avatar="user.avatar"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    user.email ? user.email : user.phone_number
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item :to="{ name: 'user.details', params: { id: user.id } }">
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logoutConfirmDialog = true">
                <v-list-item-title>Log out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-main>
      <div class="px-xl-12 px-lg-10 px-md-6 px-sm-4 px-xs-2">
        <slot />
      </div>
    </v-main>
    <v-dialog
      v-model="logoutConfirmDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Logout</v-card-title>
        <v-card-text>
          <strong>Are you sure you want to logout ?</strong>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            text
            @click="logoutConfirmDialog = false"
          >Cancel</v-btn>
          <v-btn
            color="primary"
            text
            @click="logout"
          >Logout</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import { mapState, mapActions, mapGetters } from 'vuex'
import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'MainLayout',

  components: {
    UserAvatar
  },

  mixins: [ControlsMixin],

  data () {
    return {
      navItems: {
        ADMIN:
          [
            { label: 'Articles', to: { name: 'articles' } },
            { label: 'Associated Press', to: { name: 'associated-press' } },
            {
              label: 'Newsletter',
              to: { name: 'newsletter' }
            },
            { label: 'Users', to: { name: 'users' } },
            { label: 'User Guides', to: { name: 'user-guides' } },
            { label: 'Onboarding', to: { name: 'onboarding' } },
            { label: 'Publishers', to: { name: 'publishers' } },
            { label: 'Tags', to: { name: 'tags' } },
            { label: 'SportsBooks', to: { name: 'sportsbooks' } },
            { label: 'Promos', to: { name: 'sportsbooks.promo' } },
            { label: 'Best Promos', to: { name: 'sportsbooks.best-promo' } },
            { label: 'Welcome Promos', to: { name: 'sportsbooks.welcome-promo' } }
          ],
        PUBLISHER:
          [
            { label: 'Articles', to: { name: 'articles' } },
            { label: 'Associated Press', to: { name: 'associated-press' } }
          ]
      },
      logoutConfirmDialog: false,
      articles: [
        { label: 'Article List', to: { name: 'articles' }, icon: 'mdi-newspaper' },
        { label: 'Associated Press', to: { name: 'associated-press' }, icon: 'mdi-newspaper-variant-outline' },
        { label: 'User Guides', to: { name: 'user-guides' }, icon: 'mdi-account-details' }
      ],
      bookmakers: [
        { label: 'SportsBooks', to: { name: 'sportsbooks' }, icon: 'mdi-clipboard-list' },
        { label: 'Promos', to: { name: 'sportsbooks.promo' }, icon: 'mdi-currency-usd-circle' },
        { label: 'In Article Promos', to: { name: 'in-article-promos' }, icon: 'mdi-currency-usd-circle' },
        { label: 'Best Promos', to: { name: 'sportsbooks.best-promo' }, icon: 'mdi-currency-usd-circle' },
        { label: 'Welcome Promos', to: { name: 'sportsbooks.welcome-promo' }, icon: 'mdi-currency-usd-circle' }
      ],
      settings: [
        { label: 'App Redirects', to: { name: 'app-redirects' }, icon: 'mdi-link-variant' },
        { label: 'App Settings', to: { name: 'app-settings' }, icon: 'mdi-cellphone-settings' },
        // { label: 'BetHub Pages Settings', to: { name: 'bethub-pages' }, icon: 'mdi-currency-usd' },
        { label: 'BestBooks Page Settings', to: { name: 'bestbooks-settings' }, icon: 'mdi-page-layout-header' },
        { label: 'BestBooks Menu Settings', to: { name: 'bestbooks-menu-settings' }, icon: 'mdi-form-select' },
        { label: 'BetHub SEO Settings', to: { name: 'bethub-seo-templates' }, icon: 'mdi-clipboard-edit-outline' },
        { label: 'Best Odds Page Settings', to: { name: 'best-odds-page-settings' }, icon: 'mdi-chart-areaspline' },
        { label: 'Futures Page Settings', to: { name: 'futures-page-settings' }, icon: 'mdi-briefcase-clock' },
        { label: 'Best Pops Page Settings', to: { name: 'best-props-page-settings' }, icon: 'mdi-file-chart' },
        { label: 'Best Bets Page Settings', to: { name: 'best-bets-page-settings' }, icon: 'mdi-chart-bar' },
        { label: 'Page Settings', to: { name: 'page-settings' }, icon: 'mdi-checkbook' }
      ],
      sports: [
        { label: 'Leagues', to: { name: 'tags' }, icon: 'mdi-tag-multiple' },
        { label: 'Matches SEO', to: { name: 'bethub-pages' }, icon: 'mdi-currency-usd' },
        { label: 'Teams', to: { name: 'teams-and-players' }, icon: 'mdi-basketball-hoop' }
      ],
      sportsbetting: [
        { label: 'Articles', to: { name: 'sports-betting' }, icon: 'mdi-library' },
        { label: 'Categories', to: { name: 'sportsbetting-categories' }, icon: 'mdi-bookshelf' },
        { label: 'Polls', to: { name: 'sportsbetting-polls' }, icon: 'mdi-poll' }
      ],
      freeToPlay: [
        { label: 'Page Details', to: { name: 'free-to-play' }, icon: 'mdi-file-question' },
        { label: 'Games Live', to: { name: 'free-to-play-games' }, icon: 'mdi-cellphone-wireless' }
      ],
      podCast: [
        { label: 'Page Details', to: { name: 'podcast' }, icon: 'mdi-file-question' },
        { label: 'Podcast Items', to: { name: 'podcast-items' }, icon: 'mdi-cellphone-wireless' }
      ]
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters({
      avatarThumb: 'auth/avatarThumb'
    })
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout'
    })
  }
}
</script>

<style scoped>
.app-logo-sheet {
  border-radius: 28px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
}
.v-navigation-drawer__border {
  background-color: transparent !important;
}
.layout-background {
  background: linear-gradient(
    90deg,
    rgba(15, 12, 43, 0.9) 0%,
    rgba(15, 12, 43, 0.9) 100%,
    rgba(16, 13, 44, 0.9) 100%,
    rgb(0, 212, 255) 100%
  );
}
.menu-item {
  margin-left: 15px !important;
}
</style>
